<template>
  <div>
    <modal-user-role :data="this.data" />
    <modal name="user_role" :adaptive="true" :height="475" :scrollable="true">
      <div class="text-center mt-5">
        <h6 class="text-gray-600 text-xl font-bold">Role</h6>
      </div>
      <div class="mt-5">
        <FormulateForm @submit="addRoles">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-4 xl:mb-0 px-2">
              <multiselect 
              v-model="selectedRoles"
              ref="multiselect"
              label="name"
              track-by="name" 
              placeholder="Select at least one role" 
              :multiple="true" 
              :options="roles" 
              :close-on-select="true" 
              :clear-on-select="false" 
              :preserve-search="true" 
              :allow-empty="false" 
              :loading="true"
              :hide-selected="true"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="selectedRoles.length &amp;&amp; !isOpen">{{ selectedRoles.length }} options selected</span>
                </template>
              </multiselect>
            </div>
           <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5 absolute bottom-0 right-0 h-16">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Add"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
/* 
  Class: ModalUserRole
  Description: This class representing a user role modal.
*/

/* Imports */
import Multiselect from 'vue-multiselect';
import RoleService from "@/services/role.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom incidents state values. 
  */
  data() {
    return {
      roles: [],
      selectedRoles: [],
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    Multiselect
  },

  /* 
    Define props from which we got user data. 
  */
  props: {
    data: null,
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call RolesService class to obtain all roles data.
    */
    getRoles() {
      RoleService.getAllRoles().then((response) => {
        this.roles = response.data.roles;
      });
    },

    /* 
      Call RolesService class to add assigned role to the certain user.
    */
    addRoles() {
      var data = { user_id: this.data.id, roles: this.selectedRoles.map((role) => role.id)};

      RoleService.assignRole(data).then(() => {
          location.reload();
      });
    },
  },

  /* 
    Load all roles after the instance.
  */
  mounted() {
    this.getRoles();
  }
};
</script>